document.addEventListener('DOMContentLoaded', () => {
  // Debug log to confirm JavaScript is running
  console.log('recipe-blog-new.js loaded');

  // Servings Scaler
  const servingsScaler = document.getElementById('servings-scaler');
  const ingredientsList = document.getElementById('ingredients-list');
  const servingsValue = document.getElementById('servings-value');

  if (servingsScaler && ingredientsList && servingsValue) {
    const originalServings = parseInt(servingsScaler.value) || 1;

    servingsScaler.addEventListener('input', () => {
      const newServings = parseInt(servingsScaler.value) || 1;
      const scaleFactor = newServings / originalServings;

      servingsValue.textContent = `${newServings} servings`;

      const ingredientItems = ingredientsList.querySelectorAll('.recipe-article--ingredient-text');
      ingredientItems.forEach(item => {
        const originalText = item.getAttribute('data-original');
        if (originalText) {
          const scaledText = scaleIngredient(originalText, scaleFactor);
          item.innerHTML = scaledText; // Use innerHTML to render the span tags
        }
      });
    });
  }

  function scaleIngredient(text, factor) {
    // Regex to match quantities: 
    // - Optional whole number (e.g., "1" in "1 1/2")
    // - Fraction (e.g., "1/2") or decimal/integer (e.g., "1.5" or "2")
    // - Optional unit (e.g., "cup")
    // - Rest of the string (e.g., "flour")
    const regex = /^(?:(\d+)\s+)?(\d+\/\d+|\d*\.?\d*)\s*(\w*)\s*(.*)$/;
    const match = text.match(regex);

    if (match) {
      let quantity;
      const whole = match[1] ? parseInt(match[1]) : 0; // Whole number part (if present)
      const fractionOrDecimal = match[2]; // Fraction (e.g., "1/2") or decimal/integer (e.g., "1.5" or "2")
      const unit = match[3]; // Unit (e.g., "cup")
      const rest = match[4]; // Rest of the string (e.g., "flour")

      // Parse the fraction or decimal part
      if (fractionOrDecimal.includes('/')) {
        const [num, denom] = fractionOrDecimal.split('/');
        if (parseInt(denom) === 0) return `zero ${unit} ${rest}`.trim(); // Handle division by zero
        quantity = whole + (parseInt(num) / parseInt(denom));
      } else {
        quantity = whole + (parseFloat(fractionOrDecimal) || 0);
      }

      // Handle edge cases
      if (isNaN(quantity)) {
        // If quantity is not a number (e.g., empty fraction like "/"), treat as zero
        quantity = 0;
      } else if (quantity < 0) {
        // Negative quantities don't make sense in recipes; treat as zero
        quantity = 0;
      }

      // Scale the quantity
      const scaledQuantity = quantity * factor;

      // Format the scaled quantity as a fraction
      const formattedQuantity = decimalToFraction(scaledQuantity);
      return `${formattedQuantity} ${unit} ${rest}`.trim();
    }

    // Handle cases where no quantity is provided (e.g., "pinch of salt")
    if (!match) {
      // Check if the text starts with a non-quantity term
      const nonQuantityRegex = /^(pinch|dash|sprig|handful|to taste)\s*(.*)$/i;
      const nonQuantityMatch = text.match(nonQuantityRegex);
      if (nonQuantityMatch) {
        // Non-quantity terms don't scale
        return text;
      }

      // If there's no quantity but a unit (e.g., "cup flour"), assume 1 and scale
      const assumedQuantityRegex = /^(\w+)\s*(.*)$/;
      const assumedMatch = text.match(assumedQuantityRegex);
      if (assumedMatch) {
        const unit = assumedMatch[1];
        const rest = assumedMatch[2];
        const assumedQuantity = 1 * factor;
        const formattedQuantity = decimalToFraction(assumedQuantity);
        return `${formattedQuantity} ${unit} ${rest}`.trim();
      }
    }

    // If parsing fails entirely, return the original text
    return text;
  }

  function decimalToFraction(decimal) {
    // Handle zero or near-zero quantities (less than 1/16 for cooking practicality)
    if (decimal <= 0 || decimal < 0.0625) { // 0.0625 is 1/16
      return 'zero';
    }

    // Separate whole number and fractional part
    const whole = Math.floor(decimal);
    const fraction = decimal - whole;

    // Define common fractions for cooking, including smaller fractions
    const fractions = [
      { value: 0, fraction: 'zero' },
      { value: 1/16, fraction: '1/16' },
      { value: 1/8, fraction: '1/8' },
      { value: 1/4, fraction: '1/4' },
      { value: 1/3, fraction: '1/3' },
      { value: 1/2, fraction: '1/2' },
      { value: 2/3, fraction: '2/3' },
      { value: 3/4, fraction: '3/4' },
      { value: 7/8, fraction: '7/8' }
    ];

    // Find the closest fraction
    let closestFraction = fractions[0].fraction;
    let minDifference = Infinity;
    for (const frac of fractions) {
      const difference = Math.abs(fraction - frac.value);
      if (difference < minDifference) {
        minDifference = difference;
        closestFraction = frac.fraction;
      }
    }

    // If the fraction part is effectively zero, return only the whole number
    if (closestFraction === 'zero') {
      // Still wrap in a fraction span for consistency, but display as a whole number
      return whole === 0 ? 'zero' : `${whole}`;
    }

    // Wrap the fraction in a span for styling
    const fractionPart = `<span class="fraction">${closestFraction}</span>`;

    // Combine whole number and fraction without a space
    if (whole === 0) {
      return fractionPart;
    }
    return `${whole}${fractionPart}`;
  }

  // Timer Detection and Creation
  const instructionItems = document.querySelectorAll('.recipe-article--instruction-item');
  instructionItems.forEach(item => {
    const instructionText = item.getAttribute('data-instruction');
    if (instructionText) {
      const words = instructionText.split(' ');
      let foundTime = false;
      words.forEach(word => {
        if (foundTime) return;

        // Detect minutes
        if (word.includes('minute') || word.includes('minutes')) {
          const minutesMatch = word.match(/^(\d+)/);
          if (minutesMatch) {
            const minutes = parseInt(minutesMatch[1]);
            const seconds = minutes * 60;
            const button = document.createElement('button');
            button.className = 'recipe-article--timer-button';
            button.innerHTML = `<svg class="icon icon-clock"><use xlink:href="#icon-clock"></use></svg> Start ${minutes} min Timer`;
            button.addEventListener('click', (e) => {
              e.stopPropagation(); // Prevent timer click from triggering instruction highlight
              startTimer(seconds, button);
            });
            item.appendChild(button);
            foundTime = true;
          }
        }
        // Detect hours
        else if (word.includes('hour') || word.includes('hours')) {
          const hoursMatch = word.match(/^(\d+)/);
          if (hoursMatch) {
            const hours = parseInt(hoursMatch[1]);
            const seconds = hours * 3600;
            const button = document.createElement('button');
            button.className = 'recipe-article--timer-button';
            button.innerHTML = `<svg class="icon icon-clock"><use xlink:href="#icon-clock"></use></svg> Start ${hours} hr Timer`;
            button.addEventListener('click', (e) => {
              e.stopPropagation(); // Prevent timer click from triggering instruction highlight
              startTimer(seconds, button);
            });
            item.appendChild(button);
            foundTime = true;
          }
        }
      });
    }
  });

  function startTimer(seconds, button) {
    let timeLeft = seconds;
    button.disabled = true;
    button.innerHTML = `<svg class="icon icon-clock"><use xlink:href="#icon-clock"></use></svg> Timer: ${formatTime(timeLeft)}`;

    const interval = setInterval(() => {
      timeLeft--;
      button.innerHTML = `<svg class="icon icon-clock"><use xlink:href="#icon-clock"></use></svg> Timer: ${formatTime(timeLeft)}`;
      if (timeLeft <= 0) {
        clearInterval(interval);
        button.innerHTML = `<svg class="icon icon-check"><use xlink:href="#icon-check"></use></svg> Timer Done!`;
        new Audio('https://freesound.org/data/previews/243/243020_4354246-lq.mp3').play();
      }
    }, 1000);
  }

  function formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }

  // Instruction Highlighting on Tap (Mobile)
  instructionItems.forEach(item => {
    // Add tabindex for keyboard accessibility
    item.setAttribute('tabindex', '0');

    item.addEventListener('click', (e) => {
      // Prevent highlighting if clicking the timer button
      if (e.target.classList.contains('recipe-article--timer-button')) return;

      // Remove highlight from all items
      instructionItems.forEach(i => i.classList.remove('is-highlighted'));
      // Add highlight to the clicked item
      item.classList.add('is-highlighted');
    });

    // Also highlight on focus for keyboard navigation
    item.addEventListener('focus', () => {
      instructionItems.forEach(i => i.classList.remove('is-highlighted'));
      item.classList.add('is-highlighted');
    });
  });

  // Shopping List Generator
  window.generateShoppingList = function() {
    const ingredients = Array.from(ingredientsList.querySelectorAll('.recipe-article--ingredient-text'))
      .map(item => {
        // Convert HTML back to plain text for the shopping list
        const div = document.createElement('div');
        div.innerHTML = item.innerHTML;
        return div.textContent; // Strips HTML tags, keeps the text (e.g., "1 1/2" instead of "1 <span>1/2</span>")
      });
    if (ingredients.length === 0) {
      alert('No ingredients available to add to the shopping list.');
      return;
    }
    const shoppingList = ingredients.join('\n');
    const blob = new Blob([shoppingList], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${document.querySelector('.recipe-article--title').textContent}-shopping-list.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Debug log to check pagination elements
  const paginationLinks = document.querySelectorAll('.article--pagination-link');
  paginationLinks.forEach(link => {
    console.log('Pagination link found:', {
      title: link.querySelector('.article--pagination-title')?.textContent,
      description: link.querySelector('.article--pagination-description')?.textContent,
      image: link.querySelector('.article--pagination-image')?.src
    });
  });
});